import { Spacing } from '@doordash/design-language'
import styled from 'styled-components'

type ImageContainerProps = {
  url: string
}
// TODO -30% for bottom fill on half the assets
export const ContentImageContainer = styled.div`
  height: 50vh;
  width: 100%;
  background-position: 50% 50%;
  background-size: 120%;
  background-image: ${(props: ImageContainerProps) => `url(${props.url})`};
`
export const SplashImageContainer = styled.div`
  height: 35vh;
  width: 100%;
  background-position: 50% 80%;
  background-size: 160%;
  background-image: ${(props: ImageContainerProps) => `url(${props.url})`};
`
export const ContentContainer = styled.div`
  padding-left: ${Spacing.Small}px;
`
